<template>
  <div class="gridwrapper">
    <Option 
      @click="selectedOption(option)"
      v-for="option in options" 
      :image="option.image"
      :imageblack="option.imageblack"
      :key="option.id" 
      :text="option.name" />
  </div>
</template>

<script>
import Option from '@/components/option.vue'

export default {
  name:"OptionSelector",
  emits:["setOption"],
  props:["options"],
  components:{
    Option
  },
  methods:{
    selectedOption(option){
      this.$emit("setOption",option);
    }
  }
}
</script>

<style scoped>
  .gridwrapper {
    margin: 0;
    padding: 0;
    font-size: 0;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: 1fr;
    grid-column-gap: 1rem;
    grid-row-gap: 16px;
    padding-top: 20px
  }

  .gridwrapper {
    padding-right: 4%;
  }

  .optionitem:hover {
    
    

    

    
  }





  @media only screen and (max-width: 1400px) {
    .gridwrapper {
      padding-right: 0px;
    }
  }

  @media only screen 
    and (min-device-width : 768px) 
    and (max-device-width : 1024px)  {
      .gridwrapper{
        grid-template-columns: repeat(2, 1fr);
      }
  }

  @media only screen and (max-width: 767px) {
    .gridwrapper{
      grid-template-columns: repeat(2, 1fr);
    }

    p{
      font-size: 18px;
    }

    .optionitem {
      background-color: white;
    }

  }


  @media only screen and (max-width:900px) and (min-width: 768px) {
    .optionitem p {
      font-size: 15px;  
    }
  }

  @media only screen and (max-width:1150px) and (min-width: 1024px) {
    .gridwrapper {
      grid-template-columns: repeat(2, 1fr);
    }
  }


  @media only screen and (max-width:1350px) and (min-width: 768px) {
    .gridwrapper {
      grid-column-gap: 15px;
    }
  }

</style>